import { Component, OnInit } from '@angular/core';
import { MegaMenuItem, MenuItem } from 'primeng/api';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {


  constructor() { }

  items: MenuItem[];

  ngOnInit(): void {
    this.items = [
      {
        label: 'Accueil',
        icon: 'pi pi-fw pi-home',
        routerLink: '/'
      },
      {
        label: 'Voiture sans permis',
        icon: 'fas fa-car',
        items: [
          { label: 'Les VSPs et le garage de MontPlaisir', routerLink: '/voiture-sans-permis' },
          { label: 'Vente de véhicule', routerLink: '/voiture-sans-permis/vente' },
          { label: 'Location', routerLink: '/voiture-sans-permis/location' },
          { label: 'Réparation', routerLink: '/voiture-sans-permis/reparation' },
          { label: 'Vente de pièce détachées', routerLink: '/voiture-sans-permis/pieces-detachees' }
        ]
      },
      {
        label: 'Carte grise',
        icon: 'pi pi-fw pi-id-card',
        items: [
          { label: 'Accompagnement & Tarif', routerLink: '/carte-grise' },
          { label: 'Demande de carte grise', routerLink: '/carte-grise/demande' },
          { label: 'Modification', routerLink: '/carte-grise/modification' },
          { label: 'Plaque d\'immatriculation', routerLink: '/carte-grise/immatriculation' }
        ]
      },
      {
        label: 'Nettoyage moteur',
        icon: 'fas fa-air-freshener',
        routerLink: '/nettoyage-moteur/decalaminage'
      },
      {
        label: 'Entretien',
        icon: 'fas fa-address-card',
        items: [
          { label: 'Pre contrôle technique', routerLink: '/entretien/pre-controle-technique' },
          { label: 'Pneu & Equilibrage & Géométrie', routerLink: '/entretien/pneu-equilibrage-geometrie' },
          { label: 'Vidange', routerLink: '/entretien/vidange' }
        ]
      },
      {
        label: 'Mécanique',
        icon: 'fas fa-tools',
        items: [
          { label: 'Réparation', routerLink: '/mecanique/automobile' },
          { label: 'Valise & Diagnostique panne', routerLink: '/mecanique/valise' },
          { label: 'La réparation des éléments mécaniques', routerLink: '/mecanique/reparation' }
        ]
      },
      {
        icon: 'fas fa-people-arrows',
        routerLink: '/social'
      }
    ];
  }

}
